'use client';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const GolfLoading = () => {
  return (
    <div className="fixed h-dvh bg-primary inset-0 z-50 flex items-center justify-center">
      <div className="flex flex-col items-center rounded-full">
        <DotLottieReact className="size-64 p-8" src="/assets/lottie/cart.json" autoplay loop />
      </div>
    </div>
  );
};

export default GolfLoading;
